<script>

    import { best_audio_offer, BestAudio } from "../../BestAudio.js";
    import { has_joined, start_panel_open } from "../../stores.js";
    import { OutputConfig } from "../../OutputConfig.js";

    export let handleClick;

    const is_mobile = OutputConfig.session.browser?.isMobile === true;

    // -- the toolbar stays mounted under the start panel: only count offers someone can see
    $: if ($best_audio_offer && $has_joined && !$start_panel_open) BestAudio.logOffered($best_audio_offer);

</script>

{#if $best_audio_offer}
    <div class="best-audio" class:mobile={is_mobile}>
        <button
            class="best-audio-btn"
            title={`Switch your microphone to ${$best_audio_offer.to_label}`}
            on:click={() => handleClick("best audio")}
        >
            <i class="fa-thin fa-headphones"></i>
            <span class="text">
                <span class="title">Click here for best audio</span>
                <span class="target">switch mic to {$best_audio_offer.to_label}</span>
            </span>
        </button>
    </div>
{/if}

<style lang="scss">

    @import "../styles/main.scss";

    // -- complement of $copper-color (same saturation/lightness, hue +180°) so the glow stands apart from the copper text/border
    $glow-color: #649fc4;

    // -- right side of the toolbar; if it wraps, the auto margin keeps it right-aligned
    // -- flex so the button sizes to its content yet can still shrink (the target ellipsizes)
    .best-audio {
        margin-left: auto;
        align-self: center;
        display: flex;
        min-width: 0;
        max-width: 360px;
    }

    .best-audio-btn {
        display: flex;
        align-items: center;
        gap: 12px;

        min-width: 0;
        height: 52px;
        padding: 0 16px 0 14px;

        font-family: inherit;
        text-align: left;
        color: #be9d86;

        border-radius: 8px;
        border: 1px solid rgba($copper-color, 0.35);
        // -- flat fill + soft glow: draws the eye without a tinted background
        background: rgba(40, 43, 54, 0.35);
        box-shadow:
            -1px 1px 0px 0px rgba(250, 235, 215, 0.2),
            0 0 12px rgba($glow-color, 0.25),
            inset 0 1px 1px rgba(255, 255, 255, 0.05);

        transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);

        &:hover {
            border-color: rgba($copper-color, 0.6);
            background: rgba(40, 43, 54, 0.45);
            transform: translateY(-1px);
            box-shadow:
                -1px 2px 3px rgba(0, 0, 0, 0.2),
                0 0 16px rgba($glow-color, 0.35),
                inset 0 1px 1px rgba(255, 255, 255, 0.05);
        }

        &:active {
            transform: translateY(1px);
            box-shadow: inset 0 1px 3px rgba(0, 0, 0, 0.2);
        }

        &:focus-visible {
            box-shadow: 0 0 0 4px rgba(139, 131, 142, 0.4);
        }

        i {
            flex: none;
            font-size: 22px;
            color: $copper-color;
        }
    }

    .text {
        display: flex;
        flex-direction: column;
        gap: 2px;
        min-width: 0;
    }

    .title {
        font-size: 1.4rem;
        font-weight: 500;
        color: rgba(250, 235, 215, 0.7);
        white-space: nowrap;
    }

    .target {
        font-size: 1.15rem;
        color: rgba(190, 157, 134, 0.7);
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
    }

    // -- narrow toolbar (one-col / phone): its own row at the bottom, button still content-width
    @container (max-width: 700px) {
        .best-audio {
            flex: 1 0 100%;
            max-width: none;
            margin-left: 0;
            margin-top: 10px;
        }
    }

    .best-audio.mobile {
        flex: 1 0 100%;
        max-width: none;
        margin-left: 0;
        margin-top: 10px;
    }

</style>
